import {Environment} from './environment.interface';
import {Env} from './env.enum';
import * as devEnvironment from './environment.dev';

export const environment: Environment = {
  ...devEnvironment.environment,
  production: Env.STAGING,
  apiUrl: 'https://app.attestio.fr/api/v1'
};
